import React from 'react';
import { makeStyles } from "@material-ui/core";
import { useTranslations } from "examsbook-react-sdk/custom-hooks";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ExamImg from '../assets/images/exam-img.png';
import LanguageIcon from '../assets/images/en-hn-img.png';
import Notification from '../assets/images/notification.png';
import syllabus from '../assets/images/syllabus.png';
import PracticeImg from '../assets/images/practice-test-img.png';
import TopicWiseImg from '../assets/images/topic-wise-img.png';
import ExamTopicCard from '../components/examTopicCard';
import { useNavigate } from 'react-router-dom';
import { Tabs, Tab }  from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    mainBlock: {
        marginLeft: -14,
        marginRight: -14,
        background: '#EFF5F4',
        marginTop: -14,
        '@media (min-width: 1025px)': {
            maxWidth: 700,
            margin: 'auto !important',
            border: '1px solid #eee'
        },
    },
    examNameContainer: {
        backgroundImage: 'linear-gradient(#C6F6DF, #008E76)',
        padding: 20,
        '@media (min-width: 1025px)': {
            padding: 40,
        },
    },
    examImg: {

    },
    examName: {
        color: '#fff',
        fontSize: 22,
        fontWeight: 'bold',
        margin: 0,
        marginTop: 8
    },
    totalTest: {
        marginTop: 30,
        '& span': {
            fontSize: 14,
            color: '#fff',
            paddingRight: 30
        }
    },
    language: {
        marginTop: 15,
        display: 'flex',
        alignItems: 'center',
        '& img': {
            marginRight: 6,
            width: 16
        },
        '& span': {
           fontSize: 12,
           color: '#fff'
        }
    },
    quizNameContainer: {
        padding: 20
    },
    tabContainer: {
        background: '#fff',
        '& .MuiTabs-indicator': {
            background: '#008e76'
        },
        '& button': {
            minWidth: '50%',
            width: '50%',
            color: '#aaa',
            fontWeight: 'bold',
            '@media (min-width: 1100px)': {
                padding: 20
            },
            '&.Mui-selected': {
                color: '#008e76'
            }
        }
    }
}));
const ExamTopicScreen = props => {
    const t = useTranslations();
    const classes = useStyles();
    const navigate = useNavigate();
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    function goBack() {
        navigate('/my-app');
    }
    return (
        <>
            <div className="mobile-back-to-test change-color">
                <ArrowBackIcon onClick={goBack}/>
                <span>SSC JE</span>
            </div>
            <div className={classes.mainBlock}>
                    <div className={classes.examNameContainer}>
                        <img src={ExamImg} className={classes.examImg} alt="" />
                        <h4 className={classes.examName}>SSC JE 2021</h4>
                        <div className={classes.totalTest}>
                            <span>50+ Mock Tests</span>
                            <span>30+ Topic Wise Quiz</span>
                        </div>
                        <div className={classes.language}>
                            <img src={LanguageIcon} className={classes.languageImg} alt="" />
                            <span className={classes.languageText}>Available in English, Hindi</span>
                        </div>
                    </div>
                    <div className={classes.tabContainer}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            indicatorColor="green"
                            textColor="green"
                        >
                            <Tab label="SSC JE MAINS [2021]" />
                            <Tab label="SSC JE PRE [2021]" />
                        </Tabs>
                    </div>
                    <div className={classes.quizNameContainer}>
                        <ExamTopicCard src={syllabus} testName="TIER I - MOCK TEST" />
                        <ExamTopicCard src={PracticeImg} testName="PRACTISE TEST"/>
                        <ExamTopicCard src={TopicWiseImg} testName="TOPIC WISE QUIZ"/>
                        <ExamTopicCard src={syllabus} testName="SYLLABUS"/>
                        <ExamTopicCard src={Notification} testName="NOTIFICATION"/>
                    </div>
            </div>
        </>
    );
};
export default ExamTopicScreen;